export const CSS = {
	container: 'c-AnchorInput',
	inputs: 'c__AnchorInput__inputs',
	error: 'c-AnchorInput__error',
	leftInput: 'c-AnchorInput__leftInput',
	rightInput: 'c-AnchorInput__rightInput',
	relatedSpans: 'c-AnchorInput__relatedSpans',
	MDL: {
		error: 'mdl-textfield__error',
	},
};

export const Style = {
	[CSS.container]: {
		display: 'block',
		margin: '8px 0',
		width: '100%',
	},
	[CSS.inputs]: {
		flex: 1,
		display: 'flex',
		'justify-content': 'space-between',
		[`& .${CSS.leftInput}`]: {
			width: '60%',
		},
		[`& .${CSS.rightInput}`]: {
			width: '40%',
		},
	},
	[CSS.error]: {
		visibility: 'visible',
		position: 'relative',
	},
	[CSS.relatedSpans]: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
};
